import { useEffect } from 'react';

export function useFocusCloseButton(
  focused: boolean,
  closeButton?: HTMLElement | null
) {
  useEffect(() => {
    if (focused) {
      const focusedElement =
        closeButton ||
        document.querySelector<HTMLElement>(
          '[role="button"][data-action="close"]'
        );
      if (focusedElement) {
        focusedElement.focus();
      }
    }
  }, [focused, closeButton]);
}
